import {NumberFormatValues, NumericFormat} from 'react-number-format';

interface Props {
    defaultValue?: number | string;
    onValueChange?: (value: NumberFormatValues) => any;
    className?: string;
    isAllowed?: (values: NumberFormatValues) => any;
    thousandSeparator?: boolean;
    allowLeadingZeros?: boolean;
    allowNegative?: boolean;
    displayType: 'input' | 'text';
    disabled?: boolean;
    decimalScale?: number
    value?: number | string
    onBlur?: (e: any) => any
}

/**
 * This is base component.<br/>
 * Please do not use this component, and instead use InputNumberC, InputNumberUc, DisplayNumber.
 */
export default function InputNumber({
                                        defaultValue,
                                        onValueChange,
                                        className,
                                        isAllowed,
                                        thousandSeparator,
                                        allowLeadingZeros,
                                        allowNegative,
                                        displayType,
                                        disabled,
                                        decimalScale,
                                        value,
                                        onBlur
                                    }: Props) {
    return (
        <NumericFormat
            defaultValue={defaultValue}
            onValueChange={(values) => onValueChange && onValueChange(values)}
            className={className}
            isAllowed={isAllowed}
            thousandSeparator={thousandSeparator}
            allowLeadingZeros={allowLeadingZeros}
            allowNegative={allowNegative}
            displayType={displayType}
            disabled={disabled}
            decimalScale={decimalScale}
            value={value}
            onBlur={onBlur}
        />
    );
}
